export default class Helpers {
    static redirectToNewAdmin() {
        let url = "";
        if(Helpers.isProduction()) {
            url = "https://app.crall.io/v2/#/login";
        }else{
            url = "https://app.crall.dev:3000/#/login";
        }

        window.location.href = url;
    }

	static url() {
		let ret = {};

		if(Helpers.isProduction()) {
            ret.cdn = 'https://cdn.crall.io';
            ret.ws = 'wss://events.crall.io';
        }else{
            ret.cdn = 'https://cdn.crall.dev';
            ret.ws = 'wss://app.crall.dev:1337';
        }

        return ret;
	}

    static getDomain(url) {
        var domain;
        //find & remove protocol (http, ftp, etc.) and get domain
        if (url.indexOf("://") > -1) {
            domain = url.split('/')[2];
        }
        else {
            domain = url.split('/')[0];
        }

        //find & remove port number
        domain = domain.split(':')[0];

        return domain;
    }

	static isProduction() {
		if(location.hostname.split('.').pop() == 'dev' || location.hostname == 'localhost') {
	        return false;
	    }
	    return true;
	}

	static randomStr() {
		return Math.round((Math.pow(36,20 + 1) - Math.random() * Math.pow(36, 20))).toString(36).slice(1);
	}
}



// WEBPACK FOOTER //
// /home/fabian/development/crall/www/lib/helpers/index.js